// extracted by mini-css-extract-plugin
module.exports = {"openingText":"Homepage_openingText__2eGE1","warningText":"Homepage_warningText__2lvuI","flexContainer":"Homepage_flexContainer__2LSKc"};